import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { MatButtonModule} from '@angular/material/button';

import { CompassesComponent } from './compasses.component';
import { AuthGuard } from '../guards/auth.guard';
import { CompassLibraryManageDialogModule } from '../components/compass-library-manage-dialog/compass-library-manage-dialog.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    RouterModule.forChild([
      {
        path: 'compasses',
        canActivate: [AuthGuard],
        component: CompassesComponent,
        children: []
      }
    ])
  ],
  declarations: [
    CompassesComponent
  ],
  exports: [
    CompassesComponent
  ],
  providers: [
    CompassLibraryManageDialogModule
  ]
})
export class CompassesModule { }
